import React from 'react'

import Avatar from 'components/Avatar'
import Flex from 'components/Flex'

import { Tabs } from 'antd'
import StyledTabs from 'components/TabsPaneStyles/index'
import {
  Name,
  OuterDiv,
  RowContainer,
  TopNav,
} from 'modules/DriveDetails/Style/style'
import { Address, NameAdd, StyledDrawer } from 'modules/Roles/Style/style'
import AboutCompany from 'modules/ViewSingleRole/Style/AboutCompany'
import JobDescription from 'modules/ViewSingleRole/Style/JobDescription'
const { TabPane } = Tabs

const PreviewDrawer = ({ drawer, setDrawer, viewRoleDetails }) => {
  const CheckIcon = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={64}
          IconName={viewRoleDetails?.role?.corporate?.name[0]}
          font={18}
        />
      )
    } else {
      return <Avatar size={64} src={logo} boxShadow={true} />
    }
  }

  const content = () => {
    return (

        <OuterDiv>
          <TopNav>
            <br></br>

            <Flex centerVertically>
              {CheckIcon(viewRoleDetails?.role?.corporate?.logo)}
              <NameAdd column flexStart>
                <Name>{viewRoleDetails?.role?.corporate?.name}</Name>
                <Address>{viewRoleDetails?.role?.corporate?.industry}</Address>
              </NameAdd>
            </Flex>

            <br></br>
          </TopNav>
          <RowContainer>
            <StyledTabs width={'100%'} defaultActiveKey="1">
              <TabPane tab="Job Description" key="1">
                <JobDescription viewRoleData={viewRoleDetails} />
              </TabPane>
              <TabPane tab="About Company" key="2">
                <AboutCompany viewRoleData={viewRoleDetails} />
              </TabPane>
            </StyledTabs>
          </RowContainer>
        </OuterDiv>
      
    )
  }

  return (
  
      <StyledDrawer
        width="80%"
        title={'Preview'}
        placement="right"
        closable={true}
        onClose={() => setDrawer(false)}
        visible={drawer}
        content={content()}
      />
  
  )
}

export default PreviewDrawer
